import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Button from "../../../components/shared/Button";
import "./OutageModal.css";
import { Icon } from "../../shared";

const OutageModal = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged the outage notice
    const hasAcknowledged = localStorage.getItem("outageNoticeAcknowledged");

    if (!hasAcknowledged) {
      setShow(true);
    }
  }, []);

  const handleAcknowledge = () => {
    // Store acknowledgment in localStorage
    localStorage.setItem("outageNoticeAcknowledged", "true");
    setShow(false);
  };

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered className="outage-modal">
      <Modal.Header className="outage-modal-header">
        <span className="outage-icon">
          <Icon iconName="exclamation" />
        </span>
        <Modal.Title className="outage-modal-title">{t("outageModal.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="outage-modal-body">
        <div className="outage-content">
          <div className="outage-message">
            <p>{t("outageModal.message")}</p>
            <p className="outage-details">{t("outageModal.details")}</p>
            <p className="outage-contact">
              {t("outageModal.contact")}{" "}
              <a href="mailto:aljedpo@alj.com" className="outage-contact-link">
                aljedpo@alj.com
              </a>
            </p>
            <p className="mt-3 mb-0">{t("outageModal.contact2")}</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="outage-modal-footer">
        <Button type="small-roundedRight" customize="mx-0" onClick={handleAcknowledge}>
          {t("outageModal.acknowledge")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OutageModal;
